// extracted by mini-css-extract-plugin
export var formContainer = "_c3-0";
export var message = "_c3-1";